import api from './index';

const getTimezones = async () => {
    const {data} = await api.get<{[key: string]: string}>(`/v4/timezones`)
    return data
}

const getLanguages = async () => {
    const {data} = await api.get<{[key: string]: string}>(`/v4/system-languages`)
    return data
}

export const RegionService = {
    getTimezones,
    getLanguages
};